module.exports = __webpack_public_path__ + "assets/img/wallet.f0058efe.svg";